<template>
  <v-row class="mx-auto my-3" no-gutters>
    <v-col class="d-flex flex-wrap mb-4" cols="12">
      <div v-for="(item, index) in designObject" :key="index">
        <div class="m-2 p-3 qrBtn" @click="chooseDesign(item.value)">
          <img :alt="item.value" :src="item.img">
        </div>
      </div>
    </v-col>

    <v-col class="pa-2" cols="12" md="6">
      <color-picker v-model="value.backcolor" label="رنگ پس زمینه"/>
    </v-col>

    <v-col class="d-none d-md-block pa-2" cols="6"/>

    <v-col class="pa-2" cols="12">
      <v-switch v-model="value.gradient" label="گرادینت"/>
    </v-col>

    <v-col class="pa-2" cols="12" md="6">
      <color-picker v-model="value.frontColor" label="رنگ کد"/>
    </v-col>

    <v-col v-if="value.gradient" class="pa-2" cols="12" md="6">
      <color-picker v-model="value.gradient_color" label="رنگ دوم"/>
    </v-col>
  </v-row>
</template>

<script>
import ColorPicker from "@/view/pages/qrland/components/colorPicker";

export default {
  name: "designSamples",

  components: {ColorPicker},

  props: {
    value: {
      type: Object
    }
  },

  data() {
    return {
      designObject: [
        {value: 'blob', img: '/media/designSvg/blob.svg'},
        {value: 'circle', img: '/media/designSvg/circle.svg'},
        {value: 'cross', img: '/media/designSvg/cross.svg'},
        {value: 'danger', img: '/media/designSvg/danger.svg'},
        {value: 'diamond', img: '/media/designSvg/diamond.svg'},
        {value: 'dot', img: '/media/designSvg/dot.svg'},
        {value: 'ellipse', img: '/media/designSvg/ellipse.svg'},
        {value: 'heart', img: '/media/designSvg/heart.svg'},
        {value: 'oriental', img: '/media/designSvg/oriental.svg'},
        {value: 'plus', img: '/media/designSvg/plus.svg'},
        {value: 'ribbon', img: '/media/designSvg/ribbon.svg'},
        {value: 'shake', img: '/media/designSvg/shake.svg'},
        {value: 'sparkle', img: '/media/designSvg/sparkle.svg'},
        {value: 'special-circle', img: '/media/designSvg/special-circle.svg'},
        {value: 'special-circle-orizz', img: '/media/designSvg/special-circle-orizz.svg'},
        {value: 'special-circle-vert', img: '/media/designSvg/special-circle-vert.svg'},
        {value: 'special-diamond', img: '/media/designSvg/special-diamond.svg'},
        {value: 'star', img: '/media/designSvg/star.svg'},
      ],
      backGround: {
        label: 'رنگ پس زمینه',
        value: '#DABFBFFF',
      },
      secondColor: {
        label: 'رنگ دوم',
        value: '#000000',
      },
      frontColor: {
        label: 'رنگ کد',
        value: '#000000',
      },
      gradient: false,
      qrStyleColors: {
        backcolor: '',
        frontColor: '',
        gradient_color: '',
        gradient: false,
        pattern: 'default'
      }
    }
  },
  watch: {
    value: {
      handler(value) {
        this.$emit('input', value);
      },
      deep: true,
    }
  },
  methods: {
    chooseDesign(value) {
      this.value.pattern = value;
    },
  },
}
</script>

<style scoped>
.qrBtn {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #02105c8c;
  cursor: pointer;
}

.qrBtn:hover {
  border-radius: 0 !important;
  box-shadow: none !important;
}

</style>